
/**
 * Function that obtains a file and return it.
 * @param {string} filePath String that contains the filepath.
 * @param {string} mimeType String that contains the file type.
 */
export function loadTextFileAjaxSync(filePath: string, mimeType: string): string {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', filePath, false);
    if (mimeType != null) {
        if (xmlhttp.overrideMimeType) {
            xmlhttp.overrideMimeType(mimeType);
        }
    }
    xmlhttp.send();
    if (xmlhttp.status == 200) {
        return xmlhttp.responseText;
    } else {
        return null;
    }
}
